<div class="div2" style="overflow: hidden;">
    <app-header></app-header>
    <app-mainbody></app-mainbody>
    <app-footer></app-footer>
</div>